import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { DocumentacionGuiaComponent } from "./guiaview";
import { nullsafe } from "keautils";
import { invalidateResource } from "kea-resource";

interface Props {
    value: models.DocumentacionGuias | null;
}

/**
* Componente para ver una guia generada por la documentación
*/
class DocumentacionGuiasNoRx extends React.PureComponent<Props> {
    render() {
        const { value } = this.props;
        const guias = nullsafe(value, x => x.Guias) || [];
        const datosIncompletos = guias.length == 0;

        guias.forEach(e => {
            e.SeguroViaje = ( value?.SeguroViaje != null ? value?.SeguroViaje : false )
            e.NumeroPoliza = value?.NumeroPoliza != null ? value?.NumeroPoliza : "" ;
        });

        const guiasView = guias.map(x => <DocumentacionGuiaComponent value={x} />);
        const totalEnOrigen = guias.filter(x => !x.Servicios.FletePorCobrar).map(x => x.Importes.Total).reduce((a, b) => a + b, 0);
        const totalEnDestino = guias.filter(x => x.Servicios.FletePorCobrar).map(x => x.Importes.Total).reduce((a, b) => a + b, 0);

        return (
            datosIncompletos ? 
            <div className="alert alert-danger">
                <label>Datos incompletos</label>
                <br />
                Termine de capturar los datos para ver el resumen de guías
                </div>
            :
            <div>
                <div className="row">
                    <div className="col-md-4">
                        <h4>Cantidad de guías: <label>{guiasView.length}</label></h4>
                    </div>
                    <div className="col-md-4">
                        <h4>Total en destino: <label>{kea.formatCurrency(totalEnDestino)}</label></h4>
                    </div>
                    <div className="col-md-4" style={{ textAlign: "right" }} >
                        <h4>Total en origen: <label>{kea.formatCurrency(totalEnOrigen)}</label></h4>
                    </div>
                </div>
                <kea.Link onClick={() => invalidateResource(resources.Documentacion)} >
                    Refrescar
                </kea.Link>

                {guiasView ? kea.autogrid(4, guiasView) :
                    <label>Datos de documentación incompletos</label>
                }
            </div>
        );
    }
}

export const DocumentacionGuias = componentToRx(DocumentacionGuiasNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/guias/guiasview.tsx